import { Injectable, Inject } from "@angular/core";
import { CanLoad, UrlSegment, Route } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class ContentGuard implements CanLoad {
  constructor(@Inject('contentHubEnabled') public contentHubEnabled: string | boolean) { }

  canLoad(route: Route, segments: UrlSegment[]): boolean {
    return this.contentHubEnabled === "true" || this.contentHubEnabled === true;
  }
}
